export interface PrivacySection {
  id: string;
  title: string;
  titleFr: string;
  content?: string;
  contentFr?: string;
  items?: Array<{ en: string; fr: string }>;
}

export const privacyContent: PrivacySection[] = [
  {
    id: 'introduction',
    title: '1. Information Collected',
    titleFr: '1. Informations Collectées',
    content: 'Sayaara collects the following information solely to process your financing purchase:',
    contentFr: 'Sayaara collecte les informations suivantes uniquement pour traiter votre achat de financement :',
    items: [
      { en: 'Personal information (name, date of birth, ID documents, residency details)', fr: 'Informations personnelles (nom, date de naissance, documents d\'identité, détails de résidence)' },
      { en: 'Contact details (phone, email, address)', fr: 'Coordonnées (téléphone, e-mail, adresse)' },
      { en: 'Financial information (income, employment, credit history)', fr: 'Informations financières (revenus, emploi, historique de crédit)' },
      { en: 'Uploaded documents (identity proof, proof of residency, income statements, etc.)', fr: 'Documents téléchargés (preuve d\'identité, preuve de résidence, relevés de revenus, etc.)' }
    ]
  },
  {
    id: 'useOfInformation',
    title: '2. Use of Information',
    titleFr: '2. Utilisation des Informations',
    content: 'We use the information you provide to:',
    contentFr: 'Nous utilisons les informations que vous fournissez pour :',
    items: [
      { en: 'Evaluate your financing eligibility (credit/background checks)', fr: 'Évaluer votre éligibilité au financement (vérifications de crédit/antécédents)' },
      { en: 'Draft and manage Shariah-compliant financing contracts', fr: 'Rédiger et gérer des contrats de financement conformes à la Charia' },
      { en: 'Facilitate communication between you and partnering dealerships', fr: 'Faciliter la communication entre vous et les concessionnaires partenaires' },
      { en: 'Provide customer support and service updates', fr: 'Fournir un support client et des mises à jour de service' },
      { en: 'Comply with legal and regulatory obligations', fr: 'Se conformer aux obligations légales et réglementaires' },
      { en: 'Improve user experience and optimize platform functionality', fr: 'Améliorer l\'expérience utilisateur et optimiser la fonctionnalité de la plateforme' }
    ]
  },
  {
    id: 'storageSecurity',
    title: '3. Storage & Security',
    titleFr: '3. Stockage et Sécurité',
    items: [
      { en: 'Your data is securely stored in encrypted databases.', fr: 'Vos données sont stockées de manière sécurisée dans des bases de données cryptées.' },
      { en: 'Access is strictly controlled and limited to essential personnel only.', fr: 'L\'accès est strictement contrôlé et limité au personnel essentiel uniquement.' },
      { en: 'Sayaara implements robust cybersecurity measures to protect against unauthorized access, disclosure, or misuse.', fr: 'Sayaara met en œuvre des mesures de cybersécurité robustes pour protéger contre l\'accès non autorisé, la divulgation ou l\'utilisation abusive.' }
    ]
  },
  {
    id: 'sharingInformation',
    title: '4. Sharing Your Information',
    titleFr: '4. Partage de Vos Informations',
    items: [
      { en: 'Your data will be shared strictly with the dealership involved in your transaction and our vetted partners, exclusively for purposes directly related to your car financing process.', fr: 'Vos données seront partagées strictement avec le concessionnaire impliqué dans votre transaction et nos partenaires vérifiés, exclusivement à des fins directement liées à votre processus de financement automobile.' },
      { en: 'We will never sell or share your personal information with unrelated third parties.', fr: 'Nous ne vendrons ni ne partagerons jamais vos informations personnelles avec des tiers non liés.' }
    ]
  },
  {
    id: 'dataRetention',
    title: '5. Data Retention',
    titleFr: '5. Rétention des Données',
    items: [
      { en: 'Sayaara retains your data only as long as necessary for processing your purchase, complying with regulatory standards, and managing ongoing customer relationships.', fr: 'Sayaara conserve vos données uniquement le temps nécessaire pour traiter votre achat, se conformer aux normes réglementaires et gérer les relations clients en cours.' },
      { en: 'Upon request, Sayaara can delete your data, provided there are no ongoing contractual obligations or regulatory requirements preventing deletion.', fr: 'Sur demande, Sayaara peut supprimer vos données, à condition qu\'il n\'y ait pas d\'obligations contractuelles en cours ou d\'exigences réglementaires empêchant la suppression.' }
    ]
  },
  {
    id: 'changesToPolicy',
    title: '7. Changes to Policy',
    titleFr: '7. Modifications de la Politique',
    content: 'Sayaara may periodically update this policy to reflect any changes to our practices or legal requirements. Updates will be clearly indicated on our website.',
    contentFr: 'Sayaara peut périodiquement mettre à jour cette politique pour refléter tout changement dans nos pratiques ou exigences légales. Les mises à jour seront clairement indiquées sur notre site web.'
  }
];

export const privacyRights = [
  { title: 'Access', titleFr: 'Accès', description: 'Request a copy of your personal data held by us', descriptionFr: 'Demander une copie de vos données personnelles détenues par nous' },
  { title: 'Correction', titleFr: 'Correction', description: 'Request updates or corrections to your data', descriptionFr: 'Demander des mises à jour ou corrections à vos données' },
  { title: 'Deletion', titleFr: 'Suppression', description: 'Request the deletion of your data (subject to limitations)', descriptionFr: 'Demander la suppression de vos données (sous réserve de limitations)' }
];